import { toast } from "react-hot-toast";
import CustomToast from "../components/CustomToast";

export const showCustomToast = (message, type ,options = {}) => {
  return toast.custom(
    (t) => <CustomToast message={message} t={t} type={type}/>,
    {
      duration: 5000, 
      position: 'top-right',
      ...options
    }
  );
};